<template>
  <base-container :fluid="true" class="modal-planned-video">
    <div class="modal-planned-video__video">
      <TheVideoPlayer
        :media_url="video.media_url"
        :imageUrl="video.thumbnail_url"
      />
      <VideoCardContent
        class="modal-planned-video__content"
        :nom="video.title"
        :marque="video.brand ? video.brand.name : ''"
        :description="video.description"
        :thematique="video.theme ? video.theme.name : ''"
      />
      <base-button @click.native="goToVideoDetails"
        >VOIR LA FICHE PRODUIT</base-button
      >
    </div>
  </base-container>
</template>

<script>
import VideoCardContent from "@/components/VideoCardContent.vue"
import { mapGetters } from "vuex"
import TheVideoPlayer from "@/components/TheVideoPlayer"
import permission from "@/directives/permission"
export default {
  components: {
    TheVideoPlayer,
    VideoCardContent
  },
  directives: { permission },
  computed: {
    ...mapGetters(["modal"]),
    video() {
      return this.modal.payload.plannedVideo
    }
  },
  methods: {
    goToVideoDetails() {
      this.$router.push({
        name: "videoDetails",
        params: { id: this.video.id }
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "@/styles/variables.scss";
.modal-planned-video {
  $play-button-icon-size: 15%;
  padding-top: 50px !important;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;

  &__video {
    width: 550px;
    // max-width: 60%;
    margin-right: 20px;
  }
  &__request {
    display: flex;
    flex-direction: column;
    width: 337px;
    tr {
      display: block;
      margin-bottom: 20px;
    }
    th,
    td {
      display: inline-block;
    }
    th {
      margin-right: 8px;
    }
    .button {
      margin-top: auto;
      max-width: 240px;
      margin-left: auto;
    }
  }

  &__credits {
    font-family: $font-family-muli;
    font-weight: 800;
    color: $color-accent;
    color: var(--color-accent, $color-accent);
  }
  &__usage {
    margin-top: 10px;
  }

  .video-player {
    .video-thumbnail {
      &__play-icon-container {
        width: $play-button-icon-size;
        height: $play-button-icon-size;
      }
    }
  }
}
</style>
